module.exports = __webpack_public_path__ + "static/background-desktop-1622e66f637ce713c32edb133177174e.jpg";